<template>
  <div class="bg-white pt-3 border rounded shadow-sm  p-4">

    <h3 class="text-l font-bold mb-4">
      Organization administrators
    </h3>
    <table class="table-auto w-full">
      <thead>
      <tr class="text-left border-b">
        <th class="px-4 py-2 ">#</th>
        <th class="px-4 py-2 ">Name</th>
        <th class="px-4 py-2">Email</th>
        <th class="px-4 py-2">Phone number</th>
        <th class="px-4 py-2">Role</th>
        <th class="px-4 py-2">Status</th>
        <th class="px-4 py-2"></th>
      </tr>
      </thead>
      <tbody>
      <tr class="border-b hover:bg-gray-200" v-for="(admin, index) in administrators" :key="admin.id">

        <td class="px-4 py-2 hover:text-teal-500"> {{ index + 1 }}</td>
        <td class="px-4 py-2 hover:text-teal-500">
          {{ admin.user != null ? admin.user.name : 'Pending registration' }}
        </td>
        <td class="px-4 py-2">{{ admin.invited_email_address || admin.user.email }}</td>
        <td class="px-4 py-2">{{ admin.user != null ? admin.user.phone_number : '' }}</td>
        <td class="px-4 py-2">
          <select :class="inputClass" class="bg-transparent" @change="updateAdmin($event,admin.id)">
            <option>Select role</option>
            <option :selected="admin.role_id = role.id" v-for="role in roles" :value="role.id" v-bind:key="role.id">{{ role.name }}</option>
          </select>
        </td>
        <td class="px-4 py-2">{{ admin.status }}</td>
        <td class="px-4 py-2">
          <button @click="removeAdmin(admin.id)" v-if="$store.getters.can('delete_administrators')"
                  class="bg-transparent hover:bg-red-500 text-red-500 hover:text-white py-1 px-2 border border-red-500 hover:border-transparent rounded mr-2">
            Remove
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "AdministratorsComponent",
  props: {
    orgId: String
  },
  data() {
    return {
      administrators: [],
      errors: [],
      role_id: null,
      roles: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  mounted() {
    this.getAdministrators()
    this.getRoles()
  },
  watch: {
    errors: function (errors) {
      this.$root.$emit("alert_error", errors);
    }
  },
  methods: {
    getRoles() {
      GraphQl.sendRequest('{roles{id name}}')
          .then(response => {
            this.roles = response.roles;
          })
    },
    updateAdmin(event, adminId) {
      if (!this.$store.getters.can('edit_administrators')) {
        this.$root.$emit("alert_error", ['Not allowed to edit organization administrators']);
        return;
      }
      let params = 'adminId: "' + adminId + '", roleId: "' + event.target.value + '"';
      GraphQl.sendRequest('mutation{updateAdmin(' + params + ') {code message}}')
          .then(() => {

          })
    },
    removeAdmin(adminId) {
      if (!this.$store.getters.can('delete_administrators')) {
        this.$root.$emit("alert_error", ['Not allowed to delete organization administrators']);
        return;
      }
      let params = 'adminId: "' + adminId + '"';
      GraphQl.sendRequest('mutation{removeAdmin(' + params + ') {code message}}')
          .then(() => {
            this.getAdministrators();
          })
    },
    getAdministrators() {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/administrators?organization_id=' + this.orgId)
          .then((result) => {
            this.administrators = result.data.data;
          })
          .catch(() => {
            this.errors.push("An error occurred while connecting to server")
          }).finally(() => {
      });
    }
  }
}
</script>

<style scoped>

</style>